import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IStatisticResource } from "../types";

export type IStatisticQueryParameters = {
    statistic?: RelationalValue<IStatisticResource>;
};

export type IStatisticQueryResult = IStatisticResource;

export const statisticQuery: IApiQueryFunction<IStatisticQueryParameters> = ({ statistic }) => {
    if (!statistic) {
        return;
    }

    return { method: "GET", url: `/statistics/${mapRelationalValue(statistic)}` };
};

export const useStatisticQuery = createApiQueryHook<IStatisticQueryParameters, IStatisticQueryResult>(statisticQuery);
